export default __webpack_public_path__ + "static/media/diamondEsmeralda.0ce1a5e7.svg";